import { type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@/components/ui/IconButton';
import { IcChevronLeft, IcBell } from '@/components/ui/icons';
import styles from './TopBar.module.css';

interface TopBarProps {
  title?: ReactNode;
  back?: boolean;
  bell?: boolean;
  onBellClick?: () => void;
  leading?: ReactNode;
  trailing?: ReactNode;
  variant?: 'dark' | 'light';
}

export function TopBar({
  title,
  back,
  bell,
  onBellClick,
  leading,
  trailing,
  variant = 'dark',
}: TopBarProps): JSX.Element {
  const navigate = useNavigate();
  return (
    <header className={`${styles.bar} ${styles[`v_${variant}`]}`}>
      <div className={styles.side}>
        {back && (
          <IconButton
            aria-label="Back"
            variant={variant === 'light' ? 'light' : 'soft'}
            onClick={() => navigate(-1)}
          >
            <IcChevronLeft className="reverse-on-rtl" />
          </IconButton>
        )}
        {leading}
      </div>
      {title && <div className={styles.title}>{title}</div>}
      <div className={`${styles.side} ${styles.sideEnd}`}>
        {trailing}
        {bell && (
          <IconButton
            aria-label="Notifications"
            variant={variant === 'light' ? 'light' : 'soft'}
            onClick={onBellClick}
          >
            <IcBell />
          </IconButton>
        )}
      </div>
    </header>
  );
}
